import React from 'react'

export class LunaHints extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        if (!window._isMobile) {
            return (
                <div className="luna-hints-container flex-row">
                    <div className="luna-hint-block">
                        <img src="/assets/img/layout/luna-planner-guide-01.png"/>
                        <h2>Select</h2>
                        <p>Click on a rectangle in the timeline to activate or create a new destination.</p>
                    </div>
                    <div className="luna-hint-block">
                        <img src="/assets/img/layout/luna-planner-guide-02.png"/>
                        <h2>Move</h2>
                        <p>Want to change the order of places you visit? Not a problem. Drag and drop destinations into
                            place.</p>
                    </div>
                    <div className="luna-hint-block">
                        <img src="/assets/img/layout/luna-planner-guide-03.png"/>
                        <h2>Resize</h2>
                        <p>Stay longer (or shorter) in any destination by resizing the destination within the timeline.</p>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}
